<template>
  <div>
    <section
      id="main-container"
      class="home-main-container"
      v-if="Object.keys(getTournaments).length !== 0 && Object.keys(getUser).length !== 0"
    >
      <div class="navbar-free">
        <MenuLanding v-if="true" />
        <Menu :showMenuItems="showMenuItems" v-else />
      </div>
      <ModalSeasonSelect />
      <div class="season-and-team">
        <NavBarTournamentButtonMobile />
      </div>

      <div class="home-main-container__menu-sections">
        <MenuSectionsLandingWidget />
      </div>

      <div class="content-section">
        <div v-if="this.$route.name != 'widget'"><RouterView /></div>
        <div v-else><LBets /></div>
      </div>
      <div class="statistics">
        <StatisticsModal :show="show" :game="objectGame" @closemodal="closemodal" />
      </div>
    </section>
    <Lives :show="booleanIsLiveGamesModalOpen" @close="setBooleanIsLiveGamesModalOpen(false)" />
    <Footer />
  </div>
</template>
<script>
import axios from 'axios';
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
export default {
  name: 'Widget',
  components: {
    Menu: () => import('@/components/Layout/Menu'),
    MenuLanding: () => import('@/components/Layout/MenuLandings'),
    ModalSeasonSelect: () => import('@/components/Elements/ModalSeasonSelect'),
    StatisticsModal: () => import('@/components/Modals/StatisticsModal'),
    NavBarTournamentButtonMobile: () => import('@/components/Elements/NavBarTournamentButtonMobileB2C'),
    MenuSectionsLandingWidget: () => import('@/components/Elements/MenuSectionsLandingWidget'),
    Footer: () => import('@/components/Sections/Main/Footer'),
    Lives: () => import('@/views/Lives'),
    LBets: () => import('@/views/Landing-Bets'),
  },
  data() {
    return {
      objectMainContainer: null,
      show: false,
      showMenuItems: true,
      retries: 3,
      colorsConfig: {},
      url: 'https://2dp6unm5we.execute-api.us-west-2.amazonaws.com/prod/custom_views/',
      objectGame: {
        gameId: 0,
        gameStatus: 0,
        date: 0,
        seasonId: 0,
      },
    };
  },
  computed: {
    ...mapState('leagueGeneral', ['booleanIsLiveGamesModalOpen']),
    ...mapGetters('loginGeneral', ['getUser', 'getUserType', 'getTournaments']),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        window.scrollTo({
          top: 0,
        });
      },
    },
    '$socket.connected': {
      immediate: true,
      handler(newValue) {
        this.updateIsSocketConnected(newValue);
      },
    },
  },
  methods: {
    ...mapMutations('profileGeneral', ['setColorsConfig']),
    ...mapActions('loginGeneral', ['storeTournaments']),
    ...mapMutations('general', ['setBooleanIsStatisticModalOpen']),
    ...mapMutations('leagueGeneral', ['setBooleanAreLiveGames', 'setBooleanIsLiveGamesModalOpen']),
    ...mapMutations('nextGeneral', ['updateIsSocketConnected', 'setMenuOptionActive']),
    async fillLiveGamesData(numberRetries = 3) {
      try {
        const response = await axios.get('https://qobetc4ze3.execute-api.us-east-2.amazonaws.com/prod/games/live');
        this.setBooleanAreLiveGames(!!(response.data && response.data.length));
      } catch (e) {
        if (numberRetries > 0) {
          await this.fillLiveGamesData(numberRetries - 1);
        } else {
          throw new Error(e);
        }
      }
    },
    openModal() {
      this.setBooleanIsStatisticModalOpen(true);
      this.show = true;
    },
    closemodal() {
      this.setBooleanIsStatisticModalOpen(false);
      this.show = false;
    },
    onClickGame(objectGame) {
      this.objectGame = objectGame;
      this.setMenuOptionActive(objectGame && objectGame.stringSectionName ? objectGame.stringSectionName : 'stats');
      this.openModal();
    },
    async getCustom(team) {
      try {
        // let query = '';
        // if (this.$route.params.team === 'bets') {
        //   query = `?ref=${document.referrer || 'home'}&t=1&ut=${this.user.premiumAccount ? '2' : '1'}`;
        // }
        const data = await axios
          .get(this.url + team)
          .then(response => response)
          .catch(e => {
            if (this.retries > 0) {
              this.retries = this.retries - 1;
              return this.getCustom(team);
            } else {
              this.colorsConfig = {
                logo: 'https://golstatsimages.blob.core.windows.net/content/shieldLogoPc.png',
                color: '#FFFFFF',
                headerBackground: '#242424',
                headerColor: '#FFFFFF',
                headerBorderColor: '#6EB913',
                header2Background: '#3b3b3b',
                header2Color: '#FFFFFF',
                subHeaderBackground: '#cce8b5',
                subHeaderColor: '#353535',
                type: 1,
                team_id: 0,
                tournaments: false,
                categories: 'all',
                bet_house: '',
                main_logo: '',
                secondary_logo: '',
                show_logo: false,
                url_base: '',
              };
            }
            return e;
          });
        if (data.data) {
          this.colorsConfig = data.data;
          localStorage.setItem('colorsConfig', JSON.stringify(data.data));
          this.setColorsConfig({ ...data.data });
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
  created() {
    EventBus.$on('click-game', this.onClickGame);
    window.localStorage.removeItem('widget-team');

    this.fillLiveGamesData();
    this.storeTournaments();
    window.sessionStorage.setItem('IsWidget', true);
    if (this.$route.params.team) {
      window.sessionStorage.setItem('WidgetTeam', this.$route.params.team);
    }
  },
  mounted() {
    if (this.$route.params.team) {
      localStorage.setItem('widget-team', this.$route.params.team);
    }
    if (this.isElInfomadorCalendar || this.isElInformadorCountdown || this.isElInformadorTable) {
      this.colorsConfig = {
        background: '#242424',
        backgroundheader: '#CCE8B5',
        bet_house: 'caliente',
        categories: 'all',
        color: '#CBEE6B',
        colorheader: '#132839',
        header2Background: '#132839',
        header2Color: '#FFFFFF',
        headerBackground: '#132839',
        headerBetToolBackground: '#242424',
        headerBorderColor: '#CBEE6E',
        headerColor: '#CBEE6E',
        logo: 'http://golstatsimages.blob.core.windows.net/content/escudo_golstats.png',
        main_logo: 'https://golstatsimages.blob.core.windows.net/golstats-bets/caliente_2020.svg',
        partner_id: 54,
        partner_link: '',
        partner_logo: 'https://golstatsimages.blob.core.windows.net/golstats-bets/partner-akron.jpg',
        secondary_logo: 'https://golstatsimages.blob.core.windows.net/golstats-bets/caliente_2020.svg',
        show_logo: true,
        subHeaderBackground: '#CBEE6B',
        subheaderBetToolBackground: '#151515',
        subHeaderColor: '#353535',
        team_id: 0,
        tournaments: false,
        type: this.isElInfomadorCalendar ? 15 : this.isElInformadorCountdown ? 14 : 17,
        url_base:
          'http://online.caliente.mx/promoRedirect?member=goalstats&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=web',
      };
    } else {
      this.getCustom(this.$route.params.team);
    }
  },
};
</script>
<style>
html {
  background: white;
}
</style>
<style lang="scss" scoped>
.navbar-static {
  width: 100%;
  // position: -webkit-sticky;
  height: 72px;
}
.navbar-free {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 6;
}
.statistics {
  z-index: 30 !important;
}
.home-main-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  min-height: 100%;
  position: relative;
  background: white;
  &__menu-sections {
    position: -webkit-sticky;
    position: sticky;
    padding-top: 6px;
    top: 72px;
    width: 100%;
    background-color: rgb(255, 255, 255);
    z-index: 2;
  }

  @media screen and (max-width: 1023px) {
    &__menu-sections {
      top: 52px;
    }
  }

  @media screen and (max-width: 390px) {
    &__menu-sections {
      //margin: 1em 0 2em;
    }
  }
}

.content-section {
  order: 4;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-top: 70px;
  padding-bottom: 70px;
  padding-top: 20px;
  & > div {
    height: 100%;
  }
  @media screen and (max-width: 1024px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 580px) {
    margin-top: 0px;
    padding-top: 0px;
  }
}

.section {
  order: 5;
}

.season-and-team {
  width: 100%;
  margin: 10px 0;
  display: none;

  @media screen and (max-width: 580px) {
    display: block;
    margin-top: 68px;
  }
}
@media screen and (max-width: 767px) {
  .content-section {
    background-color: #ffffff !important;
  }
}
</style>
